import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const [clickedNetworks, setClickedNetworks] = useState([]);

  const handleSocialClick = async (e, network, url) => {
    console.log(">>> [FRONTEND] handleSocialClick triggered for:", network);
    // Captura posição do clique
    const clickX = e.clientX;
    const clickY = e.clientY;
    console.log(">>> [FRONTEND] Click position:", clickX, clickY);

    // Abre a rede social imediatamente
    window.open(url, '_blank');
  };

  return (
    <footer style={{ backgroundColor: '#fff', borderTop: '1px solid var(--border-color)', padding: 'var(--spacing-xl) 0', marginTop: 'var(--spacing-xl)' }}>
      <div className="container">
        <div className="grid grid-cols-1 grid-md-3" style={{ gap: 'var(--spacing-lg)' }}>
          <div>
            <h3 style={{ color: 'var(--text-primary)', marginBottom: 'var(--spacing-md)' }}>Sobre a Otyma Farma</h3>
            <p style={{ color: 'var(--text-secondary)', fontSize: 'var(--font-size-sm)' }}>
              Otyma Farma é a sua farmácia online com as melhores ofertas. Encontre medicamentos, produtos de beleza e higiene com descontos incríveis.
            </p>

            {/* Social Buttons */}
            <div style={{ marginTop: '15px', display: 'flex', gap: '10px' }}>
              <button
                onClick={(e) => handleSocialClick(e, 'instagram', 'https://www.instagram.com/otymafarma')}
                style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '24px', color: '#E1306C' }}
                title="Siga no Instagram (+30 moedas)"
              >
                <i className="fab fa-instagram"></i>
                {clickedNetworks.includes('instagram') && <i className="fas fa-check-circle" style={{ fontSize: '12px', color: 'green', marginLeft: '-5px', verticalAlign: 'top' }}></i>}
              </button>
              <button
                onClick={(e) => handleSocialClick(e, 'youtube', 'https://www.youtube.com/@OtymaFarma')}
                style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '24px', color: '#FF0000' }}
                title="Inscreva-se no YouTube (+30 moedas)"
              >
                <i className="fab fa-youtube"></i>
                {clickedNetworks.includes('youtube') && <i className="fas fa-check-circle" style={{ fontSize: '12px', color: 'green', marginLeft: '-5px', verticalAlign: 'top' }}></i>}
              </button>
            </div>

          </div>
          <div>
            <h3 style={{ color: 'var(--text-primary)', marginBottom: 'var(--spacing-md)' }}>Links Úteis</h3>
            <ul style={{ color: 'var(--text-secondary)', fontSize: 'var(--font-size-sm)' }}>
              <li style={{ marginBottom: 'var(--spacing-sm)' }}><Link to="/">Home</Link></li>
            </ul>
          </div>
          <div>
            <h3 style={{ color: 'var(--text-primary)', marginBottom: 'var(--spacing-md)' }}>Contato</h3>
            <p style={{ color: 'var(--text-secondary)', fontSize: 'var(--font-size-sm)' }}>
              Email: contato@otymafarma.com<br />
              Telefone: (19)99351-1031
            </p>
          </div>
        </div>
        <div style={{ borderTop: '1px solid var(--border-color)', marginTop: 'var(--spacing-lg)', paddingTop: 'var(--spacing-md)', display: 'flex', flexDirection: 'column', alignItems: 'center', color: 'var(--text-secondary)', fontSize: 'var(--font-size-sm)', gap: '10px' }}>
          <div>&copy; {new Date().getFullYear()} Otyma Farma. Todos os direitos reservados.</div>
          <div style={{ opacity: 0.8, fontSize: '11px', marginTop: '2px' }}>
            KitFarma - CNPJ 57.880.546/0001-00
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '5px' }}>
            <span>Desenvolvido por:</span>
            <a
              href="https://www.instagram.com/devaspect?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', transition: 'opacity 0.2s' }}
              onMouseOver={(e) => e.currentTarget.style.opacity = '0.8'}
              onMouseOut={(e) => e.currentTarget.style.opacity = '1'}
            >
              <img src="/logo-dev.png" alt="DevAspect" style={{ height: '30px', width: 'auto' }} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
